import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'பக்கம் கிடைக்கவில்லை',
  title: 'அந்தப் பக்கத்தை எங்களால் கண்டுபிடிக்க முடியவில்லை',
  body: 'இணைப்பு பழையதாக இருக்கலாம், அல்லது பக்கம் நீக்கப்பட்டிருக்கலாம். நீங்கள் எதைத் தேடுகிறீர்கள் என்று சொல்லுங்கள், நாங்கள் கண்டுபிடித்துத் தருகிறோம்.',
  suggestionsTitle: 'நீங்கள் தேடுவது இவையாக இருக்கலாம்',
  bestMatchTitle: 'இதைத்தான் தேடினீர்களா',
  prefillHint: 'நீங்கள் முயன்ற முகவரியிலிருந்து முன்கூட்டியே நிரப்பப்பட்டது',
  goHome: 'முகப்பு',
  browseAll: 'அனைத்து வகைகளும்',
  reportBrokenLink: 'உடைந்த இணைப்பைப் புகாரளி',
  noticeTitle: 'அந்தப் பக்கம் கிடைக்கவில்லை',
  noticeSearching: 'அதற்குப் பதிலாக {query} என்று தேடுகிறோம்…',
  noticePrefilled: 'கீழே {query} என்று தேடுங்கள், அல்லது நீங்கள் எதைத் தேடுகிறீர்கள் என்று சொல்லுங்கள்.',
  errorTitle: 'ஏதோ தவறு நடந்துவிட்டது',
  errorBody: 'இந்தப் பக்கத்தை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும், அல்லது உங்களுக்குத் தேவையானதைக் கீழே தேடுங்கள்.',
  retry: 'மீண்டும் முயற்சிக்கவும்',
  streamLostTitle: 'இந்தப் பக்கத்தை எங்களால் முடிக்க முடியவில்லை',
  streamLostBody: 'பக்கம் சேமிக்கப்படுவதற்கு முன்பே தேடல் நின்றுவிட்டது. மீண்டும் தொடங்குங்கள், நீங்கள் எழுதியதிலிருந்தே தொடர்வோம்.',
  relaunch: 'மீண்டும் தேடு',
};
